import { sorted } from "src/helpers";
import { ReviewerTrackingDailyEntry } from "src/store/api/generatedApi";

export type ConsumptionSplit = Readonly<{
  missed: number;
  overshot: number;
  missedCreated: number;
  missedIntroduced: number;
  overshotRemoved: number;
  overshotDeleted: number;
}>;

export const splitFromEntry = (
  entry: ReviewerTrackingDailyEntry
): ConsumptionSplit => ({
  missed:
    entry.consumption_events_created + entry.consumption_events_introduced,
  overshot: entry.consumption_events_deleted + entry.consumption_events_removed,
  missedCreated: entry.consumption_events_created,
  missedIntroduced: entry.consumption_events_introduced,
  overshotRemoved: entry.consumption_events_removed,
  overshotDeleted: entry.consumption_events_deleted,
});

export const addSplits = (
  accumulator: ConsumptionSplit,
  contribution: ConsumptionSplit
): ConsumptionSplit => ({
  missed: accumulator.missed + contribution.missed,
  overshot: accumulator.overshot + contribution.overshot,
  missedCreated: accumulator.missedCreated + contribution.missedCreated,
  missedIntroduced:
    accumulator.missedIntroduced + contribution.missedIntroduced,
  overshotRemoved: accumulator.overshotRemoved + contribution.overshotRemoved,
  overshotDeleted: accumulator.overshotDeleted + contribution.overshotDeleted,
});

export type DailySplits = Readonly<{
  dates: readonly string[];
  splits: readonly ConsumptionSplit[];
}>;

export const aggregateDailySplits = (
  entries: readonly ReviewerTrackingDailyEntry[]
): DailySplits => {
  const splitsByDate = new Map<string, ConsumptionSplit>();
  for (const entry of entries) {
    const existing = splitsByDate.get(entry.footage_date);
    const contribution = splitFromEntry(entry);
    splitsByDate.set(
      entry.footage_date,
      existing === undefined ? contribution : addSplits(existing, contribution)
    );
  }
  const sortedDates = sorted([...splitsByDate.keys()], (date) => date);
  return {
    dates: sortedDates,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    splits: sortedDates.map((date) => splitsByDate.get(date)!),
  };
};
